module.exports = __webpack_public_path__ + "static/media/phone.75fd77d7.svg";